import { makeStyles } from "@material-ui/core/";

export default makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    width: 480,
  },
  title: {
    fontSize: theme.spacing(3),
    fontWeight: 500,
    lineHeight: `${theme.spacing(4)}px`,
    marginBottom: theme.spacing(3),
  },
  fileNameValue: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: "148px",
    whiteSpace: "nowrap",
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: theme.spacing(2),
    "& #browse-attachment-modal": {
      display: "none",
    },
  },
  submitButton: {
    marginLeft: theme.spacing(3),
  },
  submitButtonEndIcon: {
    color: theme.palette.grey[600],
  },
}));
